import Content from '../../../UI/Content/Content'
import css from './InstagramFeed.module.scss'
import Image from '../../../UI/Image/Image'
import { instagram } from '../../../../data/instagram'

const InstagramFeed = () => {
  return (
    <div className={css.Container}>
      <Content>
        <h1>@GirlsDefense.it</h1>
        <ul className={css.UlFeed}>
          <li>
            <h2>Seguici per rimanere aggiornato sulle nostre attività</h2>
            <p>
              Pubblichiamo costantemente foto e video delle nostre attività, ma
              anche consigli e suggerimenti per la tua sicurezza.
            </p>

            <a
              href='https://instagram.com/girlsdefense.it'
              target='_blank'
              rel='noreferrer'
              className={css.FollowUs}
            >
              Seguici su Instagram
            </a>
          </li>
          <li>
            {instagram.map((i) => (
              <a
                key={i.id}
                href='https://instagram.com/girlsdefense.it'
                target='_blank'
                rel='noreferrer'
              >
                <Image
                  src={i.image}
                  alt='Post Instagram di Girls Defense'
                  width={i.width}
                  height={i.height}
                />
              </a>
            ))}
          </li>
        </ul>
      </Content>
    </div>
    // <div className={css.Container}>
    //
    // </div>
  )
}

export default InstagramFeed
